// src/components/ResetPasswordDialog.vue

<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title>Password Reset</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="email"
          label="Enter your email"
          type="email"
          required
        ></v-text-field>
        <v-alert v-if="errorMessage" type="error" dismissible>{{ errorMessage }}</v-alert>
        <v-alert v-if="successMessage" type="success" dismissible>{{ successMessage }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">{{ successMessage ? 'OK' : 'Cancel' }}</v-btn>
        <v-btn text color="primary" @click="resetPassword">Reset Password</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase'; // Adjust path as needed

export default {
  name: 'ResetPasswordDialog',
  data() {
    return {
      dialog: true,
      email: '',
      errorMessage: '',
      successMessage: '',
    };
  },
  methods: {
    async resetPassword() {
      try {
        await sendPasswordResetEmail(auth, this.email);
        this.successMessage = 'Password reset email sent. Please check your inbox.';
        this.errorMessage = ''; // Clear any previous errors
      } catch (error) {
        this.errorMessage = error.message;
        this.successMessage = ''; // Clear any previous success messages
      }
    },
    close() {
      this.dialog = false;
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
/* Add custom styles for the reset password dialog if needed */
</style>
